<template>
    <div class="v-box-date-box2">
        <div
            class="icon animated bounceIn"
            :style="`background-color:${option.iconBack};color:${option.iconColor}`"
        >
            <i :class="option.icon" />
        </div>
        <div class="animated fadeInRight">
            <h5 class="animated bounceIn">{{ option.title }}</h5>
            <h1 class="animated bounceIn">
                <avue-count-up
                    :end="option.number"
                    :decimals="2"
                    :start="option.number - 1000 > 0 ? +(option.number - 1000) : +option.number"
                />
            </h1>
        </div>
        <div>
            <component
                :is="option.type"
                :colors="option.colors"
                :rows="option.rows"
            ></component>
        </div>
    </div>
</template>

<script>
export default {
    name: "VBoxDateBox2",
    components: {
        ELine: () => import("./ELine"),
        EHistogram: () => import("./EHistogram"),
        EPie: () => import("./EPie"),
        ESignal: () => import("./ESignal"),
    },
    props: {
        option: {
            type: Object,
            default: () => ({
                title: "",
                number: "",
                type: "",
                rows: [0, 1000, 2000, 1000, 1200, 1100, 1000, 1500, 3000],
                colors: ["#d76e7c", "#FFF"],
                icon: "",
            }),
        },
    },
};
</script>

<style lang="scss" scoped>
.v-box-date-box2 {
    display: flex;
    flex-flow: row;
    min-height: 120px;
    padding: 1.5rem 1rem 0 1.5rem;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 5px #ccc;
    &:hover {
        box-shadow: 0 0 10px #888;
    }
    > div {
        &:first-child {
            width: 3rem;
            height: 3rem;
            background: #ccc;
        }
        &:nth-child(2),
        &:last-child {
            flex: 1;
        }
        &:nth-child(2) {
            padding-left: 1rem;
        }
    }
    .icon {
        background-color: #c5f3cc;
        color: #61c97e;
        border-radius: 0.5rem;
        width: 4.4rem;
        text-align: center;
        line-height: 1.5;
        i {
            font-size: 2rem;
        }
    }
    h5 {
        color: #0079fe;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
    }
    h1{
        margin: auto;
    }
}
</style>
